import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ItineraryOverview from '../../components/ItineraryOverview';
import RecommendationSlider from '../../components/RecommendationSlider';
import PlannerContainer from '../../components/PlannerContainer';
import CartSumInfo from '../../components/CartSumInfo';
import NoActiveCruiseNotice from "../../components/NoActiveCruisesNotice";
import { setIsItineraryShown } from "../../actions/locationActions";
import BackLink from "../../components/BackLink";
import ThemableComponent from "../../components/theme/ThemableComponent";
import { getExcursionsText, getItineraryTitleText, getProjectName, getBackToDashboardText } from "../../utils/themeUtils";
import { getExternalDashboardUrl } from "../../utils/configUtils";
import { Trans, useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';

const Itinerary = () => {
    const cruises = useSelector(state => state.cruises ? state.cruises.cruiseDetails : null);
    const authentication = useSelector(state => state.authentication);

    const {t} = useLingui();

    useEffect(() => {
        setIsItineraryShown(true);
        return () => setIsItineraryShown(false);
    }, []);

    const externalDashboardUrl = getExternalDashboardUrl();
    const excursionsText = getExcursionsText();

    const tradePortalBookingUrl = authentication?.tradeportal?.bookingUrl || "";
    const backUrl = tradePortalBookingUrl || externalDashboardUrl || t({id: "/dashboard"});
    const isExternal = !!tradePortalBookingUrl || !!externalDashboardUrl;

    const getBackLinkText = () => {
        if (tradePortalBookingUrl) {
            return getBackToDashboardText(true);
        }
        return <Trans id="back_to_cruise_control_dashboard">Back to {getProjectName()} Dashboard</Trans>
    }

    return (
        <div>
            <PlannerContainer sticky={true} />
            <div className="container mx-auto">
                <div className="mt-4">
                    <BackLink to={backUrl} isExternal={isExternal} text={getBackLinkText()}/>
                </div>
                <h1>{getItineraryTitleText()}</h1>
                {cruises && cruises.length === 0 &&
                    <NoActiveCruiseNotice />
                }
                {cruises && cruises.length > 0 &&
                <>
                    <ItineraryOverview/>
                    {/*cost sum and continue button*/}
                    <CartSumInfo onClick={() => {navigate(t({id: '/checkout'}))}} />
                </>
                }
            </div>
            <RecommendationSlider
                title={t({
                    id: "recommended_shore_excursions",
                    message: `Recommended Destination ${excursionsText}`
                })}
                path="prebooking/cruises/recommendedExcursions"
            />
            <ThemableComponent componentName="WhyBookWithUs"/>
        </div>
    );
};

export default Itinerary;
